<template>
  <div class="container-fluid full-height--view">
    <div class="row full-height">
      <div class="main-body col-12">
        <div class="row header-container">
          <div class="header-left">
            <ForceBack v-if="forceBack.enabled" :forceBack="forceBack"></ForceBack>
            <HamburgerNav v-else class="flex-center" :showSideNav.sync="showSideNav" :navLinks="navLinks"></HamburgerNav>
          </div>
          <header class="header-middle">
            <slot name="header"></slot>
          </header>
          <div class="header-right">
            <slot name="header-right"></slot>
          </div>
        </div>
        <div class="row expand-height">
          <div class="col-12">
            <main class="mobile-main full-height">
              <slot></slot>
            </main>
          </div>
        </div>
        <div v-if="footerSlot" class="row base-bar">
          <footer class="col-12 mobile-footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HamburgerNav from '@/components/layouts/HamburgerNav'
import ForceBack from '@/components/layouts/ForceBack'
export default {
  name: 'MobileView',
  components: { HamburgerNav, ForceBack },
  props: {
    navLinks: {
      type: Array,
      default: () => ([])
    },
    forceBack: {
      type: Object,
      default: () => ({
        distance: -1,
        enabled: false,
        text: 'Back'
      })
    }
  },
  data () {
    return {
      showSideNav: false
    }
  },
  computed: {
    footerSlot () {
      return typeof this.$slots.footer !== 'undefined'
    }
  }
}
</script>

<style scoped lang="scss">
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .header-container {
    height: 4em;
    border-bottom: 1px solid black;
    align-items: center;
  }
  .header-left {
    flex: 1;
  }
  .header-middle {
    flex-grow: 2;
    display: flex;
    justify-content: center;
  }
  .header-right {
    flex: 1;
    display: flex;
    justify-content: center;
  }
  .main-body {
    display: flex;
    flex-direction: column;
  }
  .full-height--view {
    height: 100%;
  }
  .full-height {
    height: 100%;
  }
  .expand-height {
    flex-grow: 1;
  }

  .top-bar {
    height: 4em;
    border-bottom: 1px solid black;
  }
  .mobile-header {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .base-bar {
    height: 4em;
    background-color: #00ed0f;
    color: white;
    border-top: 1px solid black;
  }
  .mobile-footer {
    align-items: center;
    display: flex;
    // justify-content: center;
  }
  .fixed-upper-left {
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    height: 4em;
    display: flex;
    align-items: center;
  }
</style>

